module.exports = __webpack_public_path__ + "static/media/goBack.a1d57649.svg";